import p from 'prop-types'
import React from 'react'
import { SectionContainer } from '../../../components'

import Technology from '../../../datas/models/Technology'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import TechnologyBlock from '../TechnologyBlock'

import styles from './styles'


const decorators = [
  memoized,
]

function TechnologyContent({ technologies }) {
  return (
    <div className="container">
      <div className="techno-content">
        {
        technologies.map((technology) => {
          // TODO replace when model is changed
          const feature = technology.features[0]

          return <p className="technology">{feature.title}</p>
        })
      }
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

TechnologyContent.propTypes = {
  technologies: p.arrayOf(Technology.propTypes),
}

TechnologyContent.defaultProps = {
  technologies: [],
}

TechnologyContent = chainDecorators(decorators, TechnologyContent)

export default TechnologyContent
